import { Component, ViewChild, inject } from '@angular/core';

import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { BdeoDrawer, BdeoToastService } from '@bdeo/webcomponents';
import { I18NextPipe } from 'angular-i18next';
import { NotificationService } from '../../../../services/notification.service';
import { SmartphotoService } from '../../../../services/smartphoto.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-smartphoto-report-send-drawer',
  templateUrl: './smartphoto-send-report-drawer.component.html',
  styleUrl: './smartphoto-send-report-drawer.component.scss'
})
export class SmartphotoSendReportDrawerComponent {
  @ViewChild('drawer') drawer!: { nativeElement: BdeoDrawer };
  private readonly formBuilder = inject(FormBuilder);
  private readonly notificationService = inject(NotificationService);
  private readonly smartphotoService = inject(SmartphotoService);
  private readonly i18NextService = inject(I18NextPipe);

  protected loading = false;

  public sendReportForm: FormGroup = this.formBuilder.group({
    emails: ['', [this.validateAdditionalsEmails.bind(this)]],
    comments: ['', []]
  });

  public validateAdditionalsEmails(control: AbstractControl<string[] | ''>): ValidationErrors | null {
    if (control.value === '') {
      return { required: true };
    }

    const validEmails = control.value.every((email) => Validators.email(new FormControl(email.toLowerCase())) === null);
    if (!validEmails) {
      return { invalidEmails: true };
    }

    return Validators.required(control);
  }

  public async send(): Promise<void> {
    const smartphoto = await firstValueFrom(this.smartphotoService.getCurrentSmartphoto());

    if (smartphoto && smartphoto.id) {
      try {
        this.loading = true;
        await this.notificationService.sendReport(smartphoto.id, this.sendReportForm.value.emails, this.sendReportForm.value.comments);
        this.close();
        BdeoToastService.success(this.i18NextService.transform('send_report.success_message'));
      } catch (e) {
        BdeoToastService.error(this.i18NextService.transform('send_report.error_message'));
      } finally {
        this.loading = false;
      }
    }
  }

  public open(): void {
    this.drawer.nativeElement.show = true;
  }

  public close(): void {
    this.drawer.nativeElement.show = false;
  }
}
